module.exports = __webpack_public_path__ + "media/icons/food_platter-17077c8e.svg";